import React from "react"
import {Grid, Stack} from "@mui/material";
import {formatTime} from "@/helper/method";
import {GridItem} from "@/widget/GridItem/GridItem";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {useQueryTerm} from "@/service/term.s";
import {TermPO} from "@/model/product";
import {useDrawerModal} from "@/store/global.c";

export const ViewTerm = () => {
    const {id} = useDrawerModal()
    const {data: termData, isLoading: termLoading} = useQueryTerm({id: id!})
    const term = termData?.data || {} as TermPO

    return <>
        <ResultWrapper isLoading={termLoading} isEmpty={isEmpty(term)}>
            <Stack direction={'column'} gap={2}>
                <Grid
                    spacing={3}
                    container>
                    <GridItem title={'项目名称'} content={term?.category}/>
                    <GridItem title={'创建人'}
                              content={term?.creator}/>
                    <GridItem title={'项目种类'} content={term?.kind}/>
                    <GridItem title={'级别'} content={term?.level}/>
                    <GridItem title={'受理部门'} content={term?.section}/>
                    <GridItem title={'补贴类型'} content={term?.subsidies}/>
                    <GridItem title={'获批企业'}
                              content={`${term?.subsidyNum}家`}/>
                    <GridItem title={'最高奖励'}
                              content={`${term?.maxSubsidy / 10000}万元`}/>
                    <GridItem size={12} title={'优势好处'}
                              content={term?.benefits}/>
                    <GridItem size={12} title={'适用对象'}
                              content={term?.suitables}/>
                    <GridItem title={'开始时间'}
                              content={formatTime("D", term?.startDate)}/>
                    <GridItem title={'结束时间'}
                              content={formatTime("D", term?.endDate)}/>
                    <GridItem size={12} minHeight={80} title={'政策解析'} content={term?.analyze}/>
                    <GridItem size={12} minHeight={80} title={'申报条件'} content={term?.condition}/>

                    <GridItem title={'更新时间'}
                              content={formatTime("D", term?.updatedAt)}/>
                    <GridItem title={'创建时间'}
                              content={formatTime("D", term?.createdAt)}/>
                </Grid>
            </Stack>
        </ResultWrapper>
    </>
};


